import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const AboutContainer = styled.div`
  min-height: calc(100vh - 200px);
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 2rem 0;
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const PageTitle = styled.h1`
  text-align: center;
  color: #efb348;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const Section = styled.section`
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  color: white;

  h2 {
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    color: #efb348;
    font-size: 1.5rem;
    border-bottom: 2px solid #efb348;
  }

  p {
    margin-bottom: 1rem;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.8;
    text-indent: 2em;
  }

  ul {
    padding: 0;
    list-style: none;

    li {
      padding: 0.5rem 0;
      color: rgba(255, 255, 255, 0.9);

      &:before {
        margin-right: 0.5rem;
        color: #efb348;
        font-weight: bold;
        content: '✓';
      }
    }
  }
`;

const LicenseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const LicenseCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
    margin-bottom: 1rem;
    border-radius: 8px;
  }

  h3 {
    margin-bottom: 1rem;
    color: #efb348;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    text-indent: 0;
  }
`;

const About = () => {
  const { t } = useTranslation();

  return (
    <AboutContainer>
      <ContentWrapper>
        <PageTitle>{t('about.title')}</PageTitle>

        <Section>
          <h2>{t('about.companyIntro.title')}</h2>
          <p>{t('about.companyIntro.paragraph1')}</p>
          <p>{t('about.companyIntro.paragraph2')}</p>
          <p>{t('about.companyIntro.paragraph3')}</p>
        </Section>

        <Section>
          <h2>{t('about.advantages.title')}</h2>
          <ul>
            {t('about.advantages.items', { returnObjects: true }).map(
              (item, index) => (
                <li key={index}>{item}</li>
              ),
            )}
          </ul>
        </Section>

        <Section>
          <h2>{t('about.compliance.title')}</h2>
          <p>{t('about.compliance.description')}</p>

          <LicenseGrid>
            <LicenseCard>
              <h3>{t('about.compliance.licenses.austrac.title')}</h3>
              <p>{t('about.compliance.licenses.austrac.description')}</p>
            </LicenseCard>

            <LicenseCard>
              <h3>{t('about.compliance.licenses.sgx.title')}</h3>
              <p>{t('about.compliance.licenses.sgx.description')}</p>
            </LicenseCard>

            <LicenseCard>
              <h3>{t('about.compliance.licenses.nodeFintech.title')}</h3>
              <p>{t('about.compliance.licenses.nodeFintech.description')}</p>
            </LicenseCard>
          </LicenseGrid>
        </Section>

        {/* <Section>
          <h2>{t('about.contactInfo.title')}</h2>
          <p>
            <strong>{t('about.contactInfo.companyName')}</strong>
            {t('about.contactInfo.companyNameValue')}
            <br />
            <strong>{t('about.contactInfo.tradingName')}</strong>
            {t('about.contactInfo.tradingNameValue')}
            <br />
            <strong>{t('about.contactInfo.abn')}</strong>
            {t('about.contactInfo.abnValue')}
            <br />
            <strong>{t('about.contactInfo.aan')}</strong>
            {t('about.contactInfo.aanValue')}
            <br />
            <strong>{t('about.contactInfo.address')}</strong>
            {t('about.contactInfo.addressValue')}
            <br />
            <strong>{t('about.contactInfo.email')}</strong>
            {t('about.contactInfo.emailValue')}
          </p>
        </Section> */}
      </ContentWrapper>
    </AboutContainer>
  );
};

export default About;
